import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';
import MainButton from '../../buttons/MainButton';
import classes from './StepsWrapper.module.scss';
import CustomLinearProgress from '../../CustomLinearProgress/CustomLinearProgress';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../utils/constants';
import colors from '../../../../scss/colors';
import { buttonVariants } from '../../buttons/types';

export default function StepsWrapper(props) {
  const {
    steps,
    currentStep,
    setCurrentStep,
    onSubmit,
    saving = false,
    onClose,
    disabled,
    additionalComponent,
    width = '100%',
    progressBarLength = '100%',
    withBackButton,
    disabledHandler
  } = props;
  const size = useWindowSize();
  const { t } = useTranslation();

  return (
    <div className={classes.container} style={{ width }}>
      <div className={classes.header}>
        {size.width > responsiveSizeTimesheet && (
          <div role="presentation" onClick={onClose} className={classes.close}>
            <CloseIcon fontSize="inherit" />
          </div>
        )}
        <CustomLinearProgress progress={((currentStep + 1) * 100) / steps.length} fullLength={progressBarLength} />

        {size.width > responsiveSizeTimesheet ? (
          <p className={classes.stepLable}>{`${currentStep + 1} ${t('common.general.of')} ${steps.length}`}</p>
        ) : null}
      </div>
      <div className={classes.body}>{steps[currentStep]}</div>

      <div className={classes.footer}>
        {currentStep !== 0 && withBackButton && (
          <MainButton
            rounded
            outlined
            variant={buttonVariants.PRIMARY}
            size="medium"
            forceWidth={size.width > responsiveSizeTimesheet ? '204px' : '100%'}
            action={() => {
              setCurrentStep((prev) => prev - 1);
            }}
          >
            {t('common.general.back')}
          </MainButton>
        )}
        <MainButton
          rounded
          size={size.width > responsiveSizeTimesheet ? 'medium' : 'small'}
          variant={disabled ? buttonVariants.DISABLED : buttonVariants.PRIMARY}
          forceWidth={size.width > responsiveSizeTimesheet ? '204px' : '100%'}
          action={() => {
            if (disabled) {
              disabledHandler();
              return;
            }
            if (currentStep === steps.length - 1) {
              onSubmit();
            } else {
              setCurrentStep((prev) => prev + 1);
            }
          }}
        >
          {currentStep === steps.length - 1 && !saving && t('common.general.save')}
          {currentStep === steps.length - 1 && saving && <CircularProgress size={30} sx={{ color: colors.WHITE }} />}
          {currentStep !== steps.length - 1 && t('common.general.next')}
        </MainButton>
      </div>
      {additionalComponent || null}
    </div>
  );
}
